import script from "./HrItem.vue?vue&type=script&setup=true&lang=js"
export * from "./HrItem.vue?vue&type=script&setup=true&lang=js"

import "./HrItem.vue?vue&type=style&index=0&id=5e98d4f7&lang=scss&scoped=true"
import "./HrItem.vue?vue&type=style&index=1&id=5e98d4f7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e98d4f7"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QList});
